export default __webpack_public_path__ + "static/media/product25.fc8392a9.png";